module.exports = __webpack_public_path__ + "img/app-brand.596854c1.svg";